import { render, staticRenderFns } from "./unitInsuredForm.vue?vue&type=template&id=5c29d71f&scoped=true&"
import script from "./unitInsuredForm.vue?vue&type=script&lang=js&"
export * from "./unitInsuredForm.vue?vue&type=script&lang=js&"
import style0 from "./unitInsuredForm.vue?vue&type=style&index=0&id=5c29d71f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c29d71f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c29d71f')) {
      api.createRecord('5c29d71f', component.options)
    } else {
      api.reload('5c29d71f', component.options)
    }
    module.hot.accept("./unitInsuredForm.vue?vue&type=template&id=5c29d71f&scoped=true&", function () {
      api.rerender('5c29d71f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/unitInsuredForm.vue"
export default component.exports